"use client";

import { useRef, useState } from "react";
import { explainerVideo } from "@/content/site";
import { Play } from "./icons";

/** Erklärvideo mit eigenem Startbild. Geladen wird das Video erst beim Klick. */
export function ExplainerVideo() {
  const ref = useRef<HTMLVideoElement>(null);
  const [started, setStarted] = useState(false);

  const start = () => {
    setStarted(true);
    void ref.current?.play();
  };

  return (
    <div className="relative aspect-video overflow-hidden rounded-3xl bg-navy shadow-[0_40px_90px_-40px_rgb(10_23_51_/_0.65)]">
      <video
        ref={ref}
        src={explainerVideo.src}
        poster={explainerVideo.poster}
        preload="none"
        playsInline
        controls={started}
        className="size-full object-cover"
        aria-label={explainerVideo.label}
      />
      {!started && (
        <button
          type="button"
          onClick={start}
          className="group absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-navy/85 via-navy/25 to-transparent p-6 text-left sm:p-10"
          aria-label={`${explainerVideo.label} abspielen`}
        >
          <span className="absolute left-1/2 top-1/2 grid size-16 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full bg-white text-brand shadow-[0_20px_50px_-15px_rgb(10_23_51_/_0.7)] transition-transform duration-200 group-hover:scale-105 sm:size-24">
            <Play className="ml-1 size-7 sm:size-9" />
          </span>
          <span className="inline-flex w-fit items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-xs font-semibold text-white backdrop-blur">
            Video · {explainerVideo.duration}
          </span>
          {/* Erst ab Desktop-Breite ist unter dem Play-Button Platz für den Titel. */}
          <span className="mt-3 hidden max-w-xl font-display text-4xl font-bold leading-tight text-white lg:block">
            {explainerVideo.title}
          </span>
        </button>
      )}
    </div>
  );
}
